import type { ApiError } from '@/shared/types/api';

interface AppErrorType {
  status: number;
  message: string;
  code?: string;
}

export class AppError extends Error implements AppErrorType {
  status: number;
  code?: string;

  constructor(status: number, message: string, code?: string) {
    super(message);
    this.status = status;
    this.code = code;
    this.name = 'AppError';
  }
}

export const isApiError = (error: unknown): error is ApiError => {
  return typeof error === 'object' && error !== null && 'status' in error && 'message' in error;
};

export const handleApiError = (error: unknown): AppError => {
  if (error instanceof AppError) {
    return error;
  }

  if (error instanceof Error) {
    return new AppError(500, error.message);
  }

  const apiError = error as ApiError;
  return new AppError(apiError.status || 500, apiError.message, apiError.code);
};
